import {ChangeDetectionStrategy, Component, computed, inject, signal, Signal} from '@angular/core';
import {FirebaseService} from '../../../shared/services/firebase.service';
import {ContentComponent} from "../../../shared/elements/content/content.component";
import {LanguageService} from '../../../shared/services/language.service';
import {TYPE} from '../../../shared/types/types';
import {FormButtonComponent} from "../../../shared/elements/form-button/form-button.component";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";

@Component({
  selector: 'app-browser-notifications',
  imports: [ContentComponent, FormButtonComponent, TranslatePipe],
  template: `
    <div class="d-flex flex-column my-2">
      <app-content
        [fontSize]="'fs-default'"
        [fontColor]="'text-muted'"
        >
        {{statusMessage()}}
      </app-content>
      @if(firebase.notificationState() === defaultType()){
        <app-form-button
          [icon]="'notification_important'" 
          [iconPosition]="'left'" 
          [cssClass]="'e-primary e-small fs-default fw-semibold'" 
          [iconClass]="'fs-5'"
          [text]="'REQUESTBROWSERASKNOTIFICATIONS' | translate"
          (click)="firebase.init(true)"
        >
        </app-form-button>
      }
    </div>
  `,
  styleUrl: './browser-notifications.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrowserNotificationsComponent {
  public firebase: FirebaseService = inject(FirebaseService);
  private languageService: LanguageService = inject(LanguageService);

  public defaultType: Signal<TYPE.FirebaseNotificationsState> = signal(TYPE.FirebaseNotificationsState.DEFAULT);

  public statusMessage: Signal<string> = computed(() => {
    const message = this.languageService.getTranslationByKey('BROWSERNOTIFICATIONSSTATUS') + ': ';
    switch(this.firebase.notificationState()) {
      case TYPE.FirebaseNotificationsState.INITIALIZING:
        return message + this.languageService.getTranslationByKey('BROWSERNOTIFICATIONSSTATUSINITIALIZING');
      case TYPE.FirebaseNotificationsState.UNDEFINED:
        return message + this.languageService.getTranslationByKey('BROWSERNOTIFICATIONSSTATUSUNKNOWNBROWSERSTATE');
      case TYPE.FirebaseNotificationsState.UNSUPPORTED:
        return message + this.languageService.getTranslationByKey('BROWSERNOTIFICATIONSSTATUSUNSUPPORTED');
      case TYPE.FirebaseNotificationsState.ERROR:
        return message + this.languageService.getTranslationByKey('BROWSERNOTIFICATIONSSTATUSINSTALLATIONERROR');
      case TYPE.FirebaseNotificationsState.GRANTED:
        return message + this.languageService.getTranslationByKey('BROWSERNOTIFICATIONSSTATUSGRANTED');
      case TYPE.FirebaseNotificationsState.DENIED:
        return message + this.languageService.getTranslationByKey('BROWSERNOTIFICATIONSSTATUSDENIED');
      case TYPE.FirebaseNotificationsState.DEFAULT:
        return message + this.languageService.getTranslationByKey('BROWSERNOTIFICATIONSSTATUSNOUSERACTION');
      default:
        return message + this.languageService.getTranslationByKey('BROWSERNOTIFICATIONSSTATUSUNKNOWN');
    }
  });
}
